import React, { useState } from 'react';
import './App.css';

function App() {
  const [originalText, setOriginalText] = useState('');
  const [revisedText, setRevisedText] = useState('');
  const [diffChars, setDiffChars] = useState([]);
  const [diffWords, setDiffWords] = useState([]);

  const handleOriginalChange = (e) => {
    setOriginalText(e.target.value);
  };

  const handleRevisedChange = (e) => {
    setRevisedText(e.target.value);
  };

  const compareTexts = async () => {
    // const response = await fetch('http://localhost:8787/diff', {
    // const response = await fetch('https://article-diff-api.sproutmzhou.workers.dev/diff', {
    const response = await fetch('https://article-diff-api.ilyy.online/diff', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ original: originalText, revised: revisedText }),
      // mode: 'no-cors',
    });

    try {
      const res = await response.json();
      if (res.success) {
        const data = res.data;
        setDiffChars(data && data.diffChars);
        setDiffWords(data && data.diffWords);
      } else {
        alert((res && res.message) || '未知错误, 稍后重试');
      }
    } catch (error) {
      console.log('===========>   error', error);
      alert('未知错误, 稍后重试');
    }
  };

  return (
    <div className="App">
      <h1>作文批改</h1>
      <div className="text-areas">
        <textarea placeholder="原文" value={originalText} onChange={handleOriginalChange} />
        <textarea placeholder="修改后的作文" value={revisedText} onChange={handleRevisedChange} />
      </div>
      <button onClick={compareTexts}>比较</button>
      <div className="diff-container">
        <div className="diff-output">
          {diffChars.map((part, index) => {
            let color = part.added ? 'green' : part.removed ? 'red' : 'grey';
            let decoration = part.removed ? 'line-through' : 'none';
            return (
              <span key={index} style={{ color: color, textDecoration: decoration }}>
                {part.added ? `[${part.value}]` : part.removed ? `(${part.value})` : part.value}
              </span>
            );
          })}
        </div>
        <br />
        <br />
        <br />
        <div className="diff-output">
          {diffWords.map((part, index) => {
            let color = part.added ? 'green' : part.removed ? 'red' : 'grey';
            let decoration = part.removed ? 'line-through' : 'none';
            return (
              <span key={index} style={{ color: color, textDecoration: decoration }}>
                {part.added ? `[${part.value}]` : part.removed ? `(${part.value})` : part.value}
              </span>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default App;
